import { render } from "./AcademicQualifications.vue?vue&type=template&id=ed787c8a&scoped=true"
import script from "./AcademicQualifications.vue?vue&type=script&lang=js"
export * from "./AcademicQualifications.vue?vue&type=script&lang=js"

import "./AcademicQualifications.vue?vue&type=style&index=0&id=ed787c8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed787c8a"]])

export default __exports__